import debug from 'debug';
const log = debug('linksoft:message');

let _implementation = null;

function showMessage(type, message, title, options) {
    if(_implementation && typeof _implementation.showMessage === 'function') {
        return _implementation.showMessage(type, message, title, options);
    }
    log('Message API not implemented.');
    return Promise.resolve();
}

function info(message, title, options) {
	return showMessage('info', message, title, options);
}

function success(message, title, options) {
	return showMessage('success', message, title, options);
}

function warn(message, title, options) {
	return showMessage('warn', message, title, options);
}

function error(message, title, options) {
	return showMessage('error', message, title, options);
}

function confirm(message, title, callback, options) {
    if(_implementation && typeof _implementation.showMessage === 'function') {
        if (typeof title === 'function') { // handle call without title
            options = callback;
            callback = title;
            title = null;
        }
        return _implementation.confirm(message, title, callback, options);
    }
    log('Message API not implemented.');
    return Promise.resolve();
}


function implementation(messageApiImplementation) {
    _implementation = messageApiImplementation;
}

export default {
    info,
    success,
    warn,
    error,
    confirm,

    implementation
};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/message.js